
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Cheapestcabservice() {



    const cardData =
    {
        keyword: 'Cheapest cab service in Mumbai',
        heading: 'Skyline Cabs: Cheapest cab service in Mumbai',
        headingDescription: '​Skyline Cabs offers a reliable and comfortable Cheapest cab service in Mumbai, ensuring a smooth journey to this historic city. Whether you are traveling for business, leisure, or a spiritual visit, our well-maintained vehicles and professional drivers guarantee a hassle-free experience.​​​',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "Built in 1924, the Gateway of India is one of Mumbai’s most iconic landmarks. Overlooking the Arabian Sea, this grand archway was constructed to commemorate the visit of King George V and Queen Mary. It’s a popular spot for tourists and locals alike, offering ferry rides to Elephanta Caves and scenic sunset views."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus",
        "description": "A UNESCO World Heritage Site, this historic railway station is a masterpiece of Victorian Gothic architecture blended with Indian elements. Formerly known as Victoria Terminus, it is both a functioning railway station and an architectural marvel that reflects Mumbai’s colonial past."
    },
    {
        "title": "Marine Drive",
        "description": "Also known as the Queen’s Necklace, Marine Drive is a 3.6 km-long boulevard along the coast of South Mumbai. It’s a favorite hangout for evening strolls, sunsets, and panoramic views of the city skyline. At night, the streetlights resemble a string of pearls, adding to its charm."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, a short ferry ride from the Gateway of India, these UNESCO-listed rock-cut caves date back to the 5th–8th centuries. The caves are famous for their stunning sculptures and carvings dedicated to Lord Shiva, especially the majestic Trimurti sculpture."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple in Prabhadevi is one of the most visited temples in Mumbai. Known for its spiritual energy and the faith it inspires, it draws thousands of devotees, including Bollywood celebrities and politicians."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and tomb located on an islet off the coast of Worli, Haji Ali Dargah is a symbol of Mumbai’s religious harmony. Connected to the mainland by a narrow causeway, it is both a pilgrimage site and an architectural gem offering serene sea views."
    },
    {
        "title": "Chor Bazaar",
        "description": "One of the oldest markets in Mumbai, Chor Bazaar is famous for antiques, vintage collectibles, furniture, and quirky treasures. Wandering through its crowded alleys offers a unique shopping experience and a glimpse into the city’s diverse culture and heritage."
    },
    {
        "title": "Juhu Beach",
        "description": "A popular beach destination in suburban Mumbai, Juhu Beach is known for its street food stalls, Bollywood celebrity homes, and leisurely atmosphere. It's the perfect spot for a seaside walk or indulging in local snacks like pav bhaji and bhel puri."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Located in the northern part of Mumbai, this massive national park is a green escape from the urban hustle. Home to leopards, deer, and countless bird species, it also features the ancient Kanheri Caves and offers nature trails, boating, and safaris."
    },
    {
        "title": "Colaba Causeway",
        "description": "A bustling street market near the Gateway of India, Colaba Causeway is a shopper’s paradise filled with street stalls, boutiques, cafes, and colonial-era architecture. It’s ideal for picking up souvenirs, fashion, accessories, and enjoying Mumbai’s cosmopolitan vibe."
    }
],

"services": [
    {
      "name": "Cheapest Cab Service in Mumbai",
      "description": "Skyline Cabs offers the most affordable and cheapest cab service in Mumbai without compromising on comfort and safety. Ideal for daily commutes and short trips."
    },
    {
      "name": "Affordable Taxi Mumbai",
      "description": "Looking for an affordable taxi in Mumbai? Skyline Cabs provides budget-friendly rides across the city with experienced drivers and clean vehicles."
    },
    {
      "name": "Budget Taxi Service Mumbai",
      "description": "Skyline Cabs brings you budget taxi services in Mumbai that are reliable and pocket-friendly. Perfect for city rides and short-distance travel."
    },
    {
      "name": "Cheapest Outstation Cabs in Mumbai",
      "description": "Travel out of town on a budget with Skyline Cabs. We offer the cheapest outstation cab services from Mumbai with flexible fare options."
    },
    {
      "name": "Low Cost Taxi Service Mumbai",
      "description": "Skyline Cabs provides low-cost taxi services throughout Mumbai. Get value-for-money transportation with professional service."
    }
  ],
  "tableData": [
    ["Cheapest Cab Service in Mumbai", "Affordable Taxi Mumbai"],
    ["Budget Taxi Service Mumbai", "Cheapest Outstation Cabs in Mumbai"],
    ["Low Cost Taxi Service Mumbai"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Cheapest Cab Service in Mumbai",
      "WhyChoosedescription": "Looking for affordable and reliable transportation in Mumbai? Our cheapest cab service offers great value without compromising on comfort or safety, ensuring a budget-friendly ride every time."
    },
    {
      "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
      "WhyChoosedescription": "We offer the most competitive rates for Mumbai cabs with a clear, upfront pricing structure. No hidden charges—just the best rates for your journey."
    },
    {
      "WhyChooseheading": "Comfortable and Reliable Cabs",
      "WhyChoosedescription": "Despite our low prices, we maintain high standards of comfort. Our cabs are well-maintained, clean, and equipped with air conditioning to ensure a pleasant ride."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our courteous and professional drivers ensure a safe and smooth ride while providing excellent customer service, all at the lowest possible fare."
    },
    {
      "WhyChooseheading": "Multiple Payment Options for Convenience",
      "WhyChoosedescription": "Pay via cash, card, or digital payment methods for your convenience. We offer easy payment options for a seamless travel experience."
    },
    {
      "WhyChooseheading": "Ideal for Short Trips, Commutes, and More",
      "WhyChoosedescription": "Our affordable cabs are perfect for all kinds of trips in Mumbai, whether it’s a short commute, local sightseeing, or a longer journey around the city."
    },
    {
      "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
      "WhyChoosedescription": "Every cab in our fleet is regularly sanitized and maintained to ensure safety, hygiene, and reliability, so you can travel with peace of mind."
    },
    {
      "WhyChooseheading": "24/7 Availability and Easy Booking",
      "WhyChoosedescription": "Our cheap Mumbai cab service is available 24/7. Book online or by phone anytime, and our friendly support team will assist you with your travel needs."
    }
  ]
  
  
  
  
  








    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book the cheapest cab service in Mumbai?',
            answer:
                'Booking the cheapest cab service in Mumbai is easy. You can use apps like Ola Mini, Uber Go, or local Kaali Peeli taxis. Simply enter your pickup location, select your vehicle, and confirm your booking through their app or customer support.',
        },
        {
            id: 2,
            question: 'What is the starting fare for the cheapest cabs in Mumbai?',
            answer:
                'The starting fare for the cheapest cabs like Ola Mini and Uber Go is generally around ₹25-₹30 for the first 2-3 km. After that, fares are calculated per km.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for the cheapest cab options in Mumbai?',
            answer:
                'For budget-friendly cab options, you can choose vehicles like Tata Indica, Swift Dzire, or compact cars that are part of services like Ola Mini or Uber Go.',
        },
        {
            id: 4,
            question: 'Are the fares for cheap cabs in Mumbai fixed or metered?',
            answer:
                'The fares for cheap cabs in Mumbai are generally metered, based on the distance traveled. For services like Ola Mini and Uber Go, fares are calculated using their dynamic pricing model.',
        },
        {
            id: 5,
            question: 'Can I book a one-way cab with the cheapest services in Mumbai?',
            answer:
                'Yes, services like Ola and Uber offer one-way bookings for affordable rides. You can book a cab from your location to your destination without a return trip.',
        },
        {
            id: 6,
            question: 'Can I use cash to pay for the cheapest cabs in Mumbai?',
            answer:
                'Yes, cash payment is accepted in most of the cheaper cab services like local Kaali Peeli taxis. Ola and Uber also offer cash payment options, but they are more popular for digital payments.',
        },
        {
            id: 7,
            question: 'Can I cancel or modify my booking for a cheap cab in Mumbai?',
            answer:
                'Yes, you can cancel or modify your booking through the app or by contacting customer support. Cancellation charges may apply depending on the type of ride you booked.',
        },
        {
            id: 8,
            question: 'Are there any discounts or offers on cheap cabs in Mumbai?',
            answer:
                'Yes, both Ola and Uber often have promotional offers or discount codes that you can use to get cheaper fares. Keep an eye out for any special offers on the apps.',
        },
        {
            id: 9,
            question: 'Is it safe to use the cheapest cab services in Mumbai?',
            answer:
                'Yes, services like Ola, Uber, and local taxis ensure the safety of passengers. The cabs are regularly inspected, and drivers are background checked. You can also track your ride in real-time through the app.',
        },
        {
            id: 10,
            question: 'Why should I choose the cheapest cab services in Mumbai?',
            answer:
                'The cheapest cab services in Mumbai offer affordable and convenient rides for short distances within the city. They provide flexibility in booking, transparent pricing, and safe, reliable travel options.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Rajesh Kumar",
            rating: 5,
            review: "I used Ola Mini for my trip around Mumbai. The ride was affordable, and the driver was polite. It was a smooth journey, and I highly recommend this for budget-friendly travel!"
        },
        {
            name: "Miss. Priya Verma",
            rating: 4,
            review: "The Uber Go service was great for my short-distance trip in Mumbai. The car was clean, and the driver was on time. It would be even better if they had more frequent stopovers for longer trips."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


  const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cheapest Cab Service in Mumbai",
  "image": "https://skylinecabs.com/assets/images/cheapest-cab-service-mumbai.jpg",
  "description": "Looking for the most affordable cab service in Mumbai? Skyline Cabs offers budget-friendly rides with AC sedans, hatchbacks, and SUVs across the city—available 24/7 with professional drivers and fixed pricing.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "9154"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "199",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/cheapest-cab-service-in-mumbai"
  }
};



      
    return (
        <div>

<Helmet>
  <title>Cheapest Cab Service in Mumbai | 24/7 Affordable Rides | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Looking for the most affordable cab service in Mumbai? Skyline Cabs offers budget-friendly rides with AC sedans, hatchbacks, and SUVs across the city—available 24/7 with professional drivers and fixed pricing." 
  />
  <meta 
    name="keywords" 
    content="Cheapest Cab Service in Mumbai, Budget Cab Mumbai, Affordable Taxi Mumbai, Lowest Fare Cab in Mumbai, Skyline Cabs Booking, Online Cab Booking Mumbai, Mumbai Local Cabs, Cheap Sedan Taxi Mumbai, AC Cab at Low Price Mumbai, 24/7 Economy Taxi Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      


            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/109.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cheapestcabservice;